<template>
  <section class="delete-event-user">
    <p class="delete-event-user__title">
      {{ question }}
    </p>
    <div class="form-buttons">
      <button-app
        class="form-button_cancel"
        color-scheme="gray"
        type="button"
        @clicked="closeModal"
      >
        {{ denialTitle }}
      </button-app>
      <button-app
        class="form-button_save"
        type="button"
        @clicked="handleSubmit"
        :color-scheme="variant"
      >
        <AppLoader v-if="isLoading" />
        <span v-else>{{ acceptanceTitle }}</span>
      </button-app>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { SET_CONFIRM_MODAL_INFO } from '@/store/operations/types';
import ButtonApp from '../../components/Button/ButtonApp';
import AppLoader from '../../components/AppLoader/AppLoader';

export default {
  name: 'AddEventForm',
  components: {
    ButtonApp,
    AppLoader,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapState({
      confirmModalInfo: (state) => state.operations.confirmModalInfo,
    }),
    question() {
      return this.confirmModalInfo.question || '';
    },
    acceptanceTitle() {
      return this.confirmModalInfo.acceptanceTitle || '';
    },
    denialTitle() {
      return this.confirmModalInfo.denialTitle || '';
    },
    variant() {
      return this.confirmModalInfo.variant || 'blue';
    },
    submitHandler() {
      return this.confirmModalInfo.submitHandler || (() => {});
    },
    cancelHandler() {
      return this.confirmModalInfo.cancelHandler || (() => {});
    },
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true;
      await this.submitHandler();
      this.isLoading = false;
      this.$bvModal.hide('app-confirm-modal');
    },
    closeModal() {
      this.cancelHandler();
      this.$store.commit(SET_CONFIRM_MODAL_INFO, {});
      this.$bvModal.hide('app-confirm-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-event-user {
  text-align: center;
}
.delete-event-user__title {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5em;
  text-align: center;
  letter-spacing: -0.08px;
  color: var(--text-main-color);
  margin-bottom: 24px;
  white-space: pre-line;
}
.form-buttons {
  display: flex;
  justify-content: center;
}
.form-button_cancel {
  width: 160px;
  margin: 0 8px 0 0;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
}
.form-button_save {
  margin: 0;
  width: 160px;
  height: 38px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
}
</style>
